export default {
  typography: {
    h1: 'H1 - Create Account',
    h2: 'H2 - Title of the Page',
    h3: 'H3 - Title of the Page',
    h4: 'H4 - Title of the Page',
    h5: 'H5 - Title of the Page',
    h6: 'H6 - Title of the Page',
    loremIpsum:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate\n' +
      '          dolorem eum harum illum nisi nobis quaerat unde vero? Aspernatur atque\n' +
      '          ducimus impedit laboriosam mollitia optio provident repudiandae, sed\n' +
      '          similique sit.',
  },
  buttons: {
    active: 'Active',
    disabled: 'Disabled',
    openLogin: 'Open Login Modal',
    goHome: 'Go Home and Login',
  },
  textFields: {
    outlinedLabel: 'Outlined',
    errorText: 'Error Message.',
  },
  sub: {
    title: 'I18n Test',
    key: 'hello',
    key_plural: 'hellos',
  },
};
